<template>
  <div>
    <master-crud-page
      master="notification/template"
      title="Notification Template"
      access="master_notification_template"
      pk="nttpId"
      :columns="columns"
      :fields="fields"
      :filters="filters"
      :embedded="embedded"
      :initial-filters="initialFilters"
      page-size-selectable
      forbidden-text="This module is internal only."
    />
    <phase-legend note="Each topic can have one template per phase." />
  </div>
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import PhaseLegend from '@/components/notification/PhaseLegend';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';
import { PHASE_OPTIONS, TOPIC_SOURCE, relationOf } from '@/util/notificationConfig';

const PLACEHOLDER_HINT = 'Placeholders: {asset} {company} {device} {time} {severity} {topicName} '
  + '{rule} {metric} {value} {lastSeen} {event} {duration} {expiredAt} {days} {stage} {period} {frequency}';

export default {
  name: 'MasterNotificationTemplate',
  components: { MasterCrudPage, PhaseLegend },
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    const topic = Number(this.$route.query.topic);
    return {
      // datang dari tombol Edit wording di Alert Rule
      initialFilters: topic ? { nttpNtopId: topic } : {},
      columns: [
        {
          key: 'nttpNtopId',
          label: 'Topic',
          align: 'left',
          formatter: (value, key, row) => {
            const topic = relationOf(row.nttpNtop);
            return topic ? topic.ntopName : value;
          },
        },
        {
          key: 'nttpPhase', label: 'Phase', type: 'badge', variant: () => 'info',
        },
        { key: 'nttpTitle', label: 'Title', align: 'left' },
        { key: 'nttpUpdatedUserId', label: 'Updated By' },
        {
          key: 'nttpUpdatedTime',
          label: 'Updated',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'nttpNtopId',
          label: 'Topic',
          type: 'select',
          required: true,
          searchable: true,
          source: TOPIC_SOURCE,
        },
        {
          key: 'nttpPhase', label: 'Phase', type: 'select', required: true, options: PHASE_OPTIONS, default: 'SINGLE',
        },
        {
          key: 'nttpTitle', label: 'Title', type: 'text', required: true, colMd: 12,
        },
        {
          key: 'nttpBody', label: 'Body', type: 'textarea', required: true, colMd: 12, hint: PLACEHOLDER_HINT,
        },
      ],
      filters: [
        {
          key: 'nttpNtopId', label: 'Topic', type: 'select', source: TOPIC_SOURCE, searchable: true, colMd: 4,
        },
        {
          key: 'nttpPhase', label: 'Phase', type: 'select', options: PHASE_OPTIONS, colMd: 3,
        },
      ],
    };
  },
};
</script>
